import { useEffect } from "react";
import WhyChooseUs from "@/components/WhyChooseUs";
import Testimonials from "@/components/Testimonials";
import Reveal from "@/components/SectionReveal";
import { useSeo, localBusinessJsonLd } from "@/lib/seo";
import { SITE } from "@/data/site";

export default function AboutPage() {
  useSeo({
    title: `About ${SITE.name} — 25+ Years of Tampa Bay Pool Service`,
    description:
      "Tampa Bay Pool Pros — established 2020 with 25+ years of pool industry experience. Local, friendly, licensed, and insured. Weekly pool service, green pool cleanup, filter & pump service, and 24/7 emergency repair.",
    path: "/about",
    image: SITE.logo,
    jsonLd: localBusinessJsonLd(),
  });
  useEffect(() => { window.scrollTo({ top: 0 }); }, []);

  return (
    <main className="bg-white">
      <section className="pt-32 sm:pt-44 pb-10 bg-gradient-to-br from-sky-50 via-white to-amber-50/40">
        <div className="max-w-7xl mx-auto px-6 sm:px-10">
          <Reveal>
            <p className="text-xs tracking-[0.22em] uppercase font-bold text-sky-700">
              About Tampa Bay Pool Pros
            </p>
            <h1 className="mt-3 font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900 max-w-4xl">
              {SITE.experience} of Tampa Bay pool expertise.
            </h1>
            <p className="mt-5 max-w-2xl text-slate-700 text-lg">
              Established in {SITE.established} with {SITE.experience.toLowerCase()} of pool industry experience
              behind us, Tampa Bay Pool Pros is the local team homeowners count on for honest pricing,
              consistent quality, and quick response when something goes wrong.
            </p>
          </Reveal>
        </div>
      </section>

      <WhyChooseUs />
      <Testimonials />
    </main>
  );
}
